
import Refresh from "../../../assets/filled/Refresh.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RefreshIcon({ className, dataTestid = "RefreshIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Refresh data-testid={dataTestid} className={classes} {...rest} />
  );
}
